import { Link as e } from "./components/Link.es.js";
import { EditLink as t } from "./components/EditLink.es.js";
import { actionHandler as n } from "./lib/actionHandler.es.js";
import { normalizeNode as r } from "./lib/normalizeNode.es.js";
import { Link2Icon as i } from "lucide-react";
import { jsx as a } from "react/jsx-runtime";
//#region lib/Link/index.tsx
var o = (o) => ({
	class: "inline",
	name: "core/link",
	options: o,
	componentEntry: {
		class: "inline",
		component: e,
		constraints: { normalizeNode: r }
	},
	actions: [{
		name: "link",
		tool: [() => /* @__PURE__ */ a(i, {}), t],
		hotkey: "mod+k",
		handler: n
	}]
});
//#endregion
export { o as Link };
